import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperEditDialog: {
      display: "flex",
      flexDirection: "row",
      gap: "16px 32px",
    },
    titleItem: {
      fontSize: "14px",
      fontWeight: 600,
      color: theme.palette.text.secondary,
      lineHeight: "20px",
      maxWidth: "280px",
      minWidth: "160px",
    },
    containerUploadSection: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      width: "100%",
    },
    secctionImage: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    containerImage: {
      width: "100%",
      height: "100%",
    },
    containerImageTitle: {
      display: "flex",
      flexDirection: "row",
      gap: "8px",
    },
    containerUpladedFilesCards: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      gap: "12px",
    },
    cardUploadedFilesInfo: {
      width: "218px",
      height: "200px",
      position: "relative",
      overflow: "hidden",
    },
    containerUploadedFiles: {
      display: "flex",
      flexDirection: "row",
      gap: "12px",
      flexWrap: "wrap",
    },
    containerPlaceHolderImage: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "14px",
      borderRadius: "12px",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
      backgroundColor: "rgba(16, 24, 40, 0.08)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1,
    },
    containerDeleteIcon: {
      position: "absolute",
      width: 48,
      height: 48,
      top: 8,
      right: 8,
      zIndex: 2,
      borderRadius: "12px",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
      backgroundColor: "rgba(16, 24, 40, 0.08)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
    },
  };
});
